import { Component, Input } from "@angular/core";
import { NgxSkeletonLoaderModule } from "ngx-skeleton-loader";
import { loaderItems } from "../../../../../../../../shared/src/lib/utils/common";

@Component({
  selector: "app-highlight-loader",
  standalone: true,
  imports: [NgxSkeletonLoaderModule],
  templateUrl: "./highlight-loader.component.html",
  styleUrl: "./highlight-loader.component.scss",
})
export class HighlightLoaderComponent {
  @Input() show: boolean | null = false;
  protected readonly loaderItems = loaderItems;
}
